<div class="container">
<div class=" pd-tb">
  <div class="completeProfile ">
    <div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <a routerLink="/dashboard-job">Home</a></li>
        <li class="breadcrumb-item"> <a routerLink="/employer-choice">Employers of choice</a></li>
        <li class="breadcrumb-item active"> <a>Company detail</a></li>
      </ol>
    </div>
    <h3 class="subheading flexcss">Company Details</h3>
    <div *ngIf="employerDetails" class="completeProfilecontent p-0">
      <div class="col-lg-12 col-md-12 col-sm-12  col-12">
        <div class="card-grid-2 companydetailpage">
          <div class="card-grid-2-image-left">
            <div class="image-box"> 
              <img src="{{employerDetails?.profileImage != null ? recruiterImagePath : ''}}{{employerDetails?.profileImage != null ? employerDetails?.profileImage : 'assets/images/profile-img.jpg' }}" alt="jobBox">
            </div>
            <div class="right-info">
              <a class="name-job">{{employerDetails?.companyName}}</a>
              <span class="location-small">{{employerDetails?.location}}</span>
            </div>
            <div class="arrow">
              <a href="{{employerDetails?.websiteLink}}" target="_blank" class="borderBtn pd">Visit website</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="nav nav-pills job-list mt-5 mb-5">
      <li [routerLinkActive]="'active'"><a routerLink="about">About</a></li>
      <li [routerLinkActive]="'active'"><a routerLink="jobs">Jobs</a></li>
    </ul>
    <router-outlet></router-outlet>
  </div>
</div>
</div>